'use strict';

import {element_exists} from "../functions";

export var fnCalcPayrollEmployeeAmount = function () {
    var element = '#payroll-employee-form';

    if (!element_exists(element)) return false;

    $(document).off('input', element + ' .form-control').on('input', element + ' .form-control', function (e) {
        e.preventDefault();

        console.log($(this).parents('.payroll-data-row'));
        var payrollDataId = $(this).parents('.payroll-data-row').attr('id');

        var amountInput = $('#' + payrollDataId + '_amount');


        if (amountInput !== undefined && !$(this).is(amountInput)) {

            var total = $('#' + payrollDataId + '_units').val() * $('#' + payrollDataId + '_rate').val();
            amountInput.val(total);
        }
    })
}


